import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import RateEmpty from './assets/rate-empty.svg';
import RateFill from './assets/rate-fill.svg';
import RateHalf from './assets/rate-half.svg';
import styles from './styles.pcss';
import { assertAllowedProps } from '../../utils/events';

const cx = classNames.bind(styles);

/**
 * Wrapper around three svgs allowing to switch fill level by rounding fillMeter to closest quarter
 */
const getRateImage = (fillMeter) => {
  if (fillMeter >= 0.75) return RateFill;
  if (fillMeter >= 0.25) return RateHalf;
  return RateEmpty;
};

export function RateStar({ fillMeter, isSmall, className, ...eventHandlers }) {
  assertAllowedProps(eventHandlers);
  const RateStarImage = getRateImage(fillMeter);
  return <RateStarImage className={cx('star', { small: isSmall }, className)} {...eventHandlers} />;
}

RateStar.propTypes = {
  /**
   * if fillMeter > 0.75, show full star
   * if 0.75 > fillMeter > 0.25, show half star
   * if fillMeter < 0.25, show empty star
   */
  fillMeter: PropTypes.number,
  isSmall: PropTypes.bool,
  onHover: PropTypes.func,
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};
